var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.count > 0)?_c('span',_vm._b({directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"badge badge-pill badge-danger",class:_vm.data.staticClass},'span',_vm.data.attrs,false),[_vm._v("\n    "+_vm._s(_vm.props.count)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }